import { Component, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import {ApiService} from '../../../api/api.service';
import {AssistanceCase} from '../../../models/assistancecase';
import {AssistanceService} from '../../../models/assistanceservice';
import {AssistanceCategory} from '../../../models/assistance-category';
import {Member} from '../../../models/member';
import {ConfService} from '../../../services/conf.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {IamService} from '../../../services/iam.service';
import * as _ from 'lodash';
import { LoaderService } from '../../../api/loader.service';
import { MeService } from '../../../services/me.service';
import { Group } from '../../../models/group';
import { NotificationService } from '../../../services/notification.service';
import { CASE_STATUSES } from '../../../models/assistancecase';
import { TICKET_TYPE } from 'src/app/models/assistanceticket';
import { QuestionAnswer } from 'src/app/models/questionanswer';
import moment from 'moment';

//ngAfterContentInit()
@Component({
    selector: 'app-assistance-cases',
    templateUrl: './assistance-cases.component.html',
    styleUrls: ['./assistance-cases.component.css'],
    providers: [MessageService],
    standalone: false
})
export class AssistanceCasesComponent implements OnInit, OnDestroy {
  assistancecases: any[] = [];
  editSurveyCase: AssistanceCase;
  caseLocation: any = {};
  members: any[] = [];
  ambulance_id = [19,139,155,475,518,521,522,526,619,631,637,133,916]
  information_id = [189,704]
  messageHeader = "Create Assistance Case"
  // For automatically create bill
  tickets: any[] = [];
  states: any[] = [];
  products: any[] = [];
  providers: any[] = [];
  categories: any[] = [];
  services_filter: any[] = [];
  unicom_exception: any;
  td_type: any
  fit_criteria = 1;
  fit_criteria_ = 1;
  type_case = 0
  aplica_update = 0;
  comment_user
  not_apply_details: any = [];
  originalCategories: any[] = [];
  assistancecase: AssistanceCase;
  assistancecaseInfo: AssistanceCase;
  assistancecaseTime: AssistanceCase;
  services: AssistanceService[];
  services2: any[] = [];
  countries: any[] = [];
  country_states: any[] = [];
  assistanceplans: any[] = [];
  member: Member;
  editmember = new EventEmitter<any>();
  member_id: number;
  showDialog = false;
  showDialogFilter = false;
  showDialogDownloadReport = false;
  showDialogFeedback = false;
  showPaidDialog = false;
  showSurcveyDialog = false;
  memberDialog = false;
  aplica_ = 0;
  approved_comment = ""
  approved_comment_update = ""
  // Create or update
  status_flag: string;
  memberstate_flag = 'Create';
  // Page total count
  totalCount = 0;
  bufTotalCount = 0;
  page = 1;
  newMember = new EventEmitter<Member>();
  newMemberCountry = new EventEmitter<number>();
  assistancecaseFeedback: any = {};
  assistancecasePaid: any = {};
  memberLocation: any = {};
  rating = [];
  star = [];
  selectedRecommendation = 0;
  hoverRecommendationValue = 0;
  selectCategory_id: number;
  editcategory: AssistanceCategory;
  filter: any = {
    status: 1,
    country_id: null,
    country_state_id: null,
    assistance_plan_id: null,
    assistance_id: null,
    sponsor_id: null,
    category_id: null,
    service_id:null,
    provider_id: null,
    from_date: null,
    to_date: null,
    dashboard_flag: null,
    bcx_operator: null,
    bcx_provider: null,
    ces_data: null,
    nps_data: null,
    contact_data: null,
    utcoffset: null,
    memberquery: null,
    user_id: null,
    group_type: null,
    survey_evaluated: null,
    reprocess_evaluated: null,
    created_by_user_id: null,
    programmed_ticket: null,
    exception_ticket: null,
    coverage_letter_id: null,
    assistance_provider_id: null,
    code: null,
    serial: null,
    ticket_status: null,
    sorting: 1,
    car_plate: null,
    sinister_claim: null,
    dispatcher_array:[],
    operator_array:[]
  };
  downloadReport = {
    file_type: 'csv',
    filter: {}
  };
  filterMember: Member;
  filterUserName: string = null;
  filterCreatedByUserName: string = null;
  filterCoverLetter: string = null;
  filterAssistanceProvider: string = null;
  filterCountryName: string = null;
  filterCountryStateName: string = null;
  filterPlanName: string = null;
  filterProductName: string = null;
  filterCategoryName: string = null;
  filterServiceName: string = null;
  filterProviderName: string = null;
  iAm = null;
  hasRole = null;
  startCount = new EventEmitter<any>();
  showquestions = false;
  ratings = [
    {text: 'Excellent', val: 1},
    {text: 'Good', val: 2},
    {text: 'Regular', val: 3},
    {text: 'Bad', val: 4}
  ];
  /*ratings_cov = [
    {text: 'Very satisfied', val: 1},
    {text: 'Satisfied', val: 2},
    {text: 'Somewhat Satisfied', val: 3},
    {text: 'Not at all Satisfied', val: 4}
  ];*/
/*
  answers1 = [
  {text: 'Muy Satisfecho', val: 5},
  {text: 'Satisfecho', val: 4},
  {text: 'Lo normal', val: 3},
  {text: 'Algo Satisfecho', val: 2},
  {text: 'Nada Satisfecho', val: 1}
  ];


answers2 = [
  {text: 'Muy Poco Esfuerzo', val: 5},
  {text: 'Poco Esfuerzo', val: 4},
  {text: 'Lo Normal', val: 3},
  {text: 'Algo de Esfuerzo', val: 2},
  {text: 'Demasiado Esfuerzo', val: 1}
];
*/
 answers1 =  
  { 5 : 'Muy Satisfecho',
    4 :'Satisfecho',
    3 :'Lo normal',
    2 :'Algo Satisfecho',
    1 :'Nada Satisfecho'}
  


answers2 = 
  {5:'Muy Poco Esfuerzo',
   4:'Poco Esfuerzo',
  3:'Lo Normal', 
  2:'Algo de Esfuerzo',
  1:'Demasiado Esfuerzo'}
channel = 
  {1:'Miembro',
   2:'Cliente',
   3:'Analista QA', 
   4:'Teledoctor App',
   5:'Email',
   6:'WhatsApp',
   7:'SMS',
   8:'IVR', 
   9:'SDS',
   10: 'Analista de QA'}

  ratings_cov = [
    {text: 'Muy Satisfecho', val: 1},
    {text: 'Satisfecho', val: 2},
    {text: 'Algo Satisfecho', val: 3},
    {text: 'Nada Satisfecho', val: 4}
  ];
  effort_ratings = [
    {text: 'Too Much Effort', val: 1},
    {text: 'Some Effort', val: 2},
    {text: 'Normal', val: 3},
    {text: 'Little Effort', val: 4},
    {text: 'Very Little Effort', val: 5},
  ];
  payment_method = [
    {val: 0, text: 'Transfer'},
    {val: 1, text: 'Check'}
  ];
  fieldsRequired = {
    'recommendation_rating': false
  };
  reason = [
    {'val': 0, 'text': 'Cabin'},
    {'val': 1, 'text': 'Provider'},
    {'val': 2, 'text': 'Coverage'},
    {'val': 3, 'text': 'Sales'},
  ];
  case_id: number = null;
  case_id2: number= null;
  pageAssistancecases: any[] = [];
  currentUrl: string = null;
  disabled = false;
  showReason = false;
  editevent = new EventEmitter<void>();
  caseSearchClear = new EventEmitter<boolean>();
  editsurvey = new EventEmitter<any>();
  editsurvey2 = new EventEmitter<any>();
  groupClass;
  isOnlyDispatcherRole;
  createTicket = new EventEmitter<any>();
  myTickets: Boolean = false;
  showDialogQA=false;
  showDialogQA2=false;
  showDialogAlert=false;
  temp_assistance_case;
  isTD = false
  survey_type=0
  prioriry = 0

  assistancecase_color = new Map;
  assistancecaseClient_color = new Map;
  assistancecaseOperator_color = new Map;
  assistancecaseDispatcher_color = new Map;
  assistancecaseProvider_color = new Map;

  dialogTimer = {};
  tickets_of_assistancecase = {};
  timeToAssignProvider = {};

  user;
  tip1 = 1
  tip2 = 0
  questions_officer: QuestionAnswer[]
  questions_officer_update: QuestionAnswer[]
  questions_officer_update_answers: QuestionAnswer[] = [];
  url_collaborate = ""
  public isvip = 0

  globalTimeZone = new Date()
  hourTimeZone = 0;

  dates_valid = null;
  group_type_update
  observerOnNotificationReceived: any;
  observerOnNotificationRefresh: any;
  observerOnNotificationTicektRefresh: any;
  assistance_case_id: any;

  questions_ids = [131,132,133,134,135,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,182,183,184,185,186,187,238,239,240,241,242]
  questions_id_sug = [761,762,763,764,765,766,767,768,769,770,771]
  answers_2 = 
  { 5 : 'Muy Satisfecho',
    4 :'Satisfecho',
    3 :'Lo normal',
    2 :'Algo Satisfecho',
    1 :'Nada Satisfecho'}
  
//---variables para llamada a componente generico de survey
  customer_phone=""
  id_survey=0
  currentProcessId=0
  customer_email=""
  country_id=0
  customer_name=""
  open=false;
//--para pautas
  open_modal_pauta=false;
  currentProcessIdPauta=0;
  id_pauta=0;

  sponsor_id=0;
  service_id=0;
  category_id=0;



  //---nuevo filtro de despachador
  dispatcher_array: string[] =null;
  operator_array: string[] = null;
  constructor(
    private loaderService: LoaderService,
    public conf: ConfService, private api: ApiService,
    private confirmation: ConfirmationService, private router: Router,
    private route: ActivatedRoute, private me: MeService,
    private translate: TranslateService, public iam: IamService,
    private notificationService: NotificationService,
    public messageService: MessageService) {

    if (this.router.url.includes("my-cases")) {
      this.myTickets = true;

      // Get id for user logged in to filter assistance cases
      // when myTickets enabled
      this.api.me.get()
        .promise()
        .then(data => {
          this.me.updateToken(data);
          // this.filter.user = data;
          // this.filter.user_id = data.id;
          this.filterUserName = data.name;

          if (data && data.roles && data.roles.length && data.roles.indexOf("assistance_dispatcher_medical") >= 0) {
            this.filter.user_id = data.id;
          } else {
            this.filter.dispatcher_or_creator_id = data.id;
          }
        })
        .catch(e => {
          
        })

    } else {
      this.myTickets = false;
    }

    if (route.snapshot.params['status'] != null) {
      let filter_status = parseInt(route.snapshot.params['status']);
      if (!isNaN(filter_status)) this.filter.status = filter_status;
    }
    if (route.snapshot.params['member_id'] != null) {
      this.filter.member_id = parseInt(route.snapshot.params['member_id']);
    }

    this.filter.dashboard_flag = route.snapshot.queryParams['dashboard_flag'];
    if (this.filter.dashboard_flag) {
      this.filter.status = 0;
    }

    // The query param overwrites the param of the url
    // ?status=2 overwrites /2
    if (route.snapshot.queryParams['status'] != null) {
      let filter_status = parseInt(route.snapshot.queryParams['status']);
      if (!isNaN(filter_status)) this.filter.status = filter_status;
    }
    if (route.snapshot.queryParams['country_id'] != null) {
      this.filter.country_id = parseInt(route.snapshot.queryParams['country_id']);
    }
    if (route.snapshot.queryParams['insurance_id'] != null) {
      this.filter.assistance_id = parseInt(route.snapshot.queryParams['insurance_id']);
    }
    if (route.snapshot.queryParams['provider_id'] != null) {
      this.filter.provider_id = parseInt(route.snapshot.queryParams['provider_id']);
    }
    if (route.snapshot.queryParams['category_id'] != null) {
      this.filter.category_id = parseInt(route.snapshot.queryParams['category_id']);
    }
    if (route.snapshot.queryParams['assistance_id'] != null) {
      this.filter.assistance_id = parseInt(route.snapshot.queryParams['assistance_id']);
    }
    if (route.snapshot.queryParams['sponsor_id'] != null) {
      this.filter.sponsor_id = parseInt(route.snapshot.queryParams['sponsor_id']);
    }
    if (route.snapshot.queryParams['service_id'] != null) {
      this.filter.service_id = parseInt(route.snapshot.queryParams['service_id']);
    }
    if (route.snapshot.queryParams['group_type'] != null) {
      this.filter.group_type = parseInt(route.snapshot.queryParams['group_type']);
    }
    if (route.snapshot.queryParams['survey_evaluated'] != null) {
      this.filter.survey_evaluated = (
        route.snapshot.queryParams['survey_evaluated'] == 'true'
      );
    }
    if (route.snapshot.queryParams['reprocess_evaluated'] !== null) {
      this.filter.reprocess_evaluated = (
        route.snapshot.queryParams['reprocess_evaluated']
      );
    }

    this.filter.bcx_operator = route.snapshot.queryParams['bcx_operator'];
    this.filter.bcx_provider = route.snapshot.queryParams['bcx_provider'];
    this.filter.ces_data = route.snapshot.queryParams['ces_data'];
    this.filter.nps_data = route.snapshot.queryParams['nps_data'];
    this.filter.contact_data = route.snapshot.queryParams['contact_data'];
    
    // this.filter.from_date = route.snapshot.queryParams['from_date'];
    // this.filter.to_date = route.snapshot.queryParams['to_date'];
    // Fix limit dates to 31 days only
    let to_date = moment().format("YYYY-M-D");
    let from_date = moment().subtract("days", 31).format("YYYY-M-D");
    this.filter.from_date = _.cloneDeep(from_date);
    this.filter.to_date = _.cloneDeep(to_date);
    this.validateDates();

    this.iAm = this.iam.isRole;
    this.hasRole = this.iam.hasThisRole;
    this.filter.utcoffset = new Date().getTimezoneOffset();

    this.loaderService.display(true);

    this.groupClass = Group;

    this.observerOnNotificationReceived = notificationService.notificationReceived$.subscribe( caseId => this.onNotificationReceived(caseId));
    this.observerOnNotificationRefresh = notificationService.notificationRefresh$.subscribe( payload => this.onNotificationRefresh(payload));
    this.observerOnNotificationTicektRefresh = notificationService.notificationTicketRefresh$.subscribe( payload => this.onNotificationTicektRefresh(payload));
    this.hourTimeZone = (this.globalTimeZone.getTimezoneOffset()/60)*(-1)
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.observerOnNotificationReceived.unsubscribe();
    this.observerOnNotificationRefresh.unsubscribe();
    this.observerOnNotificationTicektRefresh.unsubscribe();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (
        params['step'] == '1' ||
        params['step'] == '2' ||
        params['step'] == 'coverletter1' ||
        params['step'] == 'coverletter2' ||
        params['step'] == 'coverletter3' ||
        params['step'] == 'conection2' 
      ) {
        this.showDialog = true;
      } else {
        this.showDialog = false;
      }
    });
    this.isOnlyDispatcherRole = false;

    this.currentUrl = this.router.url;
    // Translate all the feedback options
    this.translateFeedbackOptions();

    for (let i = 0; i < 10; i++) {
      this.rating.push(i);
    }
    for (let i = 0; i < 5; i++) {
      this.star.push(i);
    }
    this.assistancecase = new AssistanceCase();
    this.member = new Member();
    this.filterMember = null;

    let roles = this.me.user.roles.toString();

    this.getAssistanceCase();
    this.api.countries.get().promise()
      .then(countries => {
        this.countries = countries.data;
        if (this.filter.country_id) {this.filterCountryName = _.find(
        this.countries, country => country.id === this.filter.country_id).name;
        // this.getProviders();
        this.api.assistances.get().filter({country_id: this.filter.country_id})
          .promise().then(resp => {
            this.products = resp.data;
            if (this.filter.assistance_id) {
              this.filterProductName = _.find(
                this.products,
                product => product.id === this.filter.assistance_id
              ).name;
            }
          });
        }
      });

    this.api.assistancecategories.get().promise()
      .then(resp => {
        this.loaderService.display(false);
        this.categories = resp.data;
        this.originalCategories = resp.data;
        if (this.filter.category_id) {
          this.filterCategoryName = _.find(
            this.categories,
            c => c.id === this.filter.category_id
          ).name;
        }
      });

    this.api.assistanceservices.getCatalog().promise()
      .then(resp => {
        this.loaderService.display(false)
        this.services_filter = resp.data
      });
  }

  isAssistanceCasesEmpty() {
    if (this.assistancecases.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getTicketsAssistanceCase(assistancecase) {
    this.tickets_of_assistancecase[assistancecase.id] = assistancecase.services[0].tickets;
  }

  getStatusCase(id) {
    let tickets = this.tickets_of_assistancecase[id];
    let status = ""
    if (tickets != undefined){
      for(let i = 0; i<tickets.length; i++) {
         if(tickets[i].ticket_type == TICKET_TYPE.REIMBURSE) {
          status = "reimbursement"
          break;
        } else if(tickets[i].ticket_type == 4) {
          status = "provider_arrived"
          break;
        } else if(tickets[i].ticket_type == 3) {
          status = "notify_provider"
          break;
        } else if(tickets[i].ticket_type == 2 && tickets[i].provider_status == 1) {
          status = "assign_provider"
          break;
        } else if(tickets[i].ticket_type == 1) {
          status = "provider_pending"
        }
      }
      return status;
    } else {
      return ""
    }
  }

  getProviderName(id) {
    let tickets = this.tickets_of_assistancecase[id];
    let status = ""
    if (tickets != undefined){
      for(let i = 0; i<tickets.length; i++) {
        if(tickets[i].ticket_type == 2 && tickets[i].provider_status == 1) {
          status = tickets[i].provider.name
          break;
        } else if (tickets[i].ticket_type == 2 && tickets[i].provider_status == 3) {
          status = "Proveedor Temporal";
          break;
        }
      }
      return status;
    } else {
      return ""
    }
  }

  completeTimer(e:any,id) {
    if(e) {
      this.timeToAssignProvider[id] = true;
    }
  }

  test(a){
    
    
    
    
  }

  setColorValue(obj){
    this.assistancecase_color.set(obj.id,obj.color);
  }

  getColorValue(id){
    
    return this.assistancecase_color.get(id)
  }

  setDialogValue(a){
    this.dialogTimer[a] = true;
  }

  setColorClientValue(obj){
    this.assistancecaseClient_color.set(obj.id,obj.color);
  }

  getColorClientValue(id){
    return this.assistancecaseClient_color.get(id)
  }

  setColorOperatorValue(obj){
    this.assistancecaseOperator_color.set(obj.id,obj.color);
  }

  getColorOperatorValue(id){
    return this.assistancecaseOperator_color.get(id)
  }

  setColorDispatcherValue(obj){
    this.assistancecaseDispatcher_color.set(obj.id,obj.color);
  }

  getColorDispatcherValue(id){
    return this.assistancecaseDispatcher_color.get(id)
  }

  setColorProviderValue(obj){
    this.assistancecaseProvider_color.set(obj.id,obj.color);
  }

  getColorProviderValue(id){
    return this.assistancecaseProvider_color.get(id)
  }

  onQueryCase(query) {
    this.filter.memberquery = '%' + query + '%';
  }

  selectCase(assistancecase) {
    if (typeof (assistancecase) === 'object' ) {
      this.assistancecases = [assistancecase];
      this.pageAssistancecases = this.assistancecases;
      this.filter.member_id = assistancecase.member_id;
      this.filterMember = assistancecase.member;
      this.filter.id = assistancecase.id;
      this.filter.status = 0;
      this.totalCount = 1;
      this.bufTotalCount = 1;
    } else {
      this.assistancecases = [];
      this.pageAssistancecases = this.assistancecases;
      this.filter.member_id = null;
      this.filter.member = null;
      this.filterMember = null;
      this.filter.id = null;
      this.totalCount = 0;
      this.bufTotalCount = 0;
    }
    this.filter.memberquery = null;
    this.getAssistanceCase();
  }

  clearCase() {
    this.assistancecases = this.pageAssistancecases;
    this.totalCount = this.bufTotalCount;
    this.filter.memberquery = null;
  }

  onSelectCaseId(case_id) {
    if (case_id) {
      this.filter.id = parseInt(case_id);

    } else {
      this.filter.id = null;
    }
  }


  onSelectPolicy(policy:string){

    this.filter.code = null;

    if (policy){
      this.filter.code = policy.trim()
    }


  }

  onSelectCarPlate(carPlate:string){
    this.filter.car_plate = null;

    if (carPlate) {
      this.filter.car_plate = carPlate.trim()
    }
  }

  onSelectSinisterClaim(sinisterClaim:string){
    this.filter.sinister_claim = null;

    if (sinisterClaim) {
      this.filter.sinister_claim = sinisterClaim.trim()
    }
  }

  onSelectSerial(serial:string){

    this.filter.serial = null;

    if (serial){
      this.filter.serial = serial.trim()
    }


  }

  onSelectSalesman(salesman:string){

    this.filter.salesman = null;

    if (salesman){
      this.filter.salesman = salesman.trim()
    }


  }

  onSelectMemberFilter(member) {
    if (member) {
      this.filter.member_id = member.id;
      this.filterMember = member;
      this.filter.member = null;
    }
  }

  onfilterByMember(member) {
    if (member) {
      this.filter.member_id = member.id;
      this.filterMember = member;
      this.filter.member = null;
    }
    this.filterAssistanceCase();
  }

  onClearSelectMember() {
    this.filter.member_id = null;
    this.filter.member = null;
    this.filterMember = null;
  }

  onQueryMember(query) {
    this.filter.member = query;
    this.filter.member_id = null;
  }

  onSelectFromDate(date) {
    this.filter.from_date = date;
    // automatically put in the field "To" the next day
    if (date && this.showDialogFilter) {
      const date_ = new Date(date);
      let to_date = new Date(date_.getTime() + (60 * 60 * 24 * 1000));
      const toNumber = to_date.getTimezoneOffset() * 60000;
      to_date = new Date(to_date.getTime() + toNumber);
      this.filter.to_date = to_date.getFullYear() + '-'
        + (to_date.getMonth() + 1) + '-' + to_date.getDate();
    }

    this.validateDates();
  }

  onSelectToDate(date) {
    this.filter.to_date = date;

    this.validateDates();
  }

  validateDates() {
    this.dates_valid = null;

    if (this.filter.from_date && this.filter.to_date) {

      let diff = moment(this.filter.to_date).diff(moment(this.filter.from_date), "days");
      if (diff >= 0 && diff <= 31) {
        this.dates_valid = true;
      } else {
        this.dates_valid = false;
      }

    } else {
      this.dates_valid = null;
    }
  }

  onSelectUser(user) {
    this.filter.user_id = user.id;
    this.filterUserName = user.name;
  }

  onClearSelectUser() {
    this.filter.user_id = null;
    this.filter.user = null;
  }

  onQueryUser(query) {
    this.filter.user = query;
    this.filter.user_id = null;
  }

  onSelectCreatedByUser(user) {
    this.filter.created_by_user_id = user.id;
    this.filterCreatedByUserName = user.name;
  }

  onSelectCoverageLetter(cover_letter) {
    this.filter.coverage_letter_id = cover_letter.id;
    this.filterCoverLetter = cover_letter.name;
  }

  onClearSelectCoverageLetter() {
    this.filter.coverage_letter_id = null;
    this.filterCoverLetter = null;
  }

  onQueryCoverageLetter(query) {
    this.filter.coverage_letter_id = query;
  }

  onSelectAssistanceProvider(assistance_provider) {
    this.filter.assistance_provider_id = assistance_provider.id;
    this.filterAssistanceProvider = assistance_provider.name;
  }

  onClearSelectAssistanceProvider() {
    this.filter.assistance_provider_id = null;
    this.filterAssistanceProvider = null;
  }

  onQueryAssistanceProvider(query) {
    this.filter.assistance_provider_id = query;
  }

  onClearSelectCreatedByUser() {
    this.filter.created_by_user_id = null;
    this.filter.created_by_user = null;
  }

  onQueryCreatedByUser(query) {
    this.filter.created_by_user = query;
    this.filter.created_by_user_id = null;
  }

  onSelectCountryFilter(country_id) {
    this.filter.assistance_id = null;
    this.filter.category_id = null;
    this.filter.provider_id = null;
    if (country_id === null) {
      this.products = [];
      this.providers = [];
      this.filterCountryName = null;
      this.filterProductName = null;
    } else {
      this.filterCountryName = _.find(
        this.countries,
        country => country.id == country_id
      ).name;
      this.api.assistances.get()
      .filter({country_id: country_id})
      .promise()
        .then(resp => {
          this.products = resp.data;
        });
      this.filter.country_id = country_id;
      this.getProviders();
    }
  }
  
  onSelectCountryStateFilter(country_state_id) {
    if (country_state_id === null) {
      this.filterCountryStateName = null;
      this.filter.country_state_id = null;
    } else {
      this.filterCountryStateName = _.find(
        this.country_states,
        country_state => country_state.id == country_state_id
      ).name;

      this.filter.country_state_id = country_state_id;
    }
  }

  onSelectProductPlan(assistance_plan_id) {
    if (assistance_plan_id === null) {
      this.filterPlanName = null;
      this.filter.assistance_plan_id = null;
    } else {
      this.filterPlanName = _.find(
        this.assistanceplans,
        plan => plan.id == assistance_plan_id
      ).name;

      this.filter.assistance_plan_id = assistance_plan_id;
    }
  }

  onSelectProduct(assistance_id) {
    // this.filter.provider_id = null;
    // this.filter.category_id = null;
    if (assistance_id) {
      this.filterProductName = _.find(
        this.products,
        product => product.id === assistance_id
      ).name;
      this.filter.assistance_id = assistance_id;
      this.filter.assistance_plan_id = null;

      const filter_plan = {'assistance_id': assistance_id};
      this.api.assistanceplans.get().filter(filter_plan).promise()
        .then(resp => {
          this.assistanceplans = resp.data;
        });
      // this.api.assistancesById.getCategoryServices(assistance_id).promise()
      //   .then(resp => {
      //     this.categories = resp;
      //   });
      // this.getProviders();
    } else {
      this.filterProductName = null;
      this.filter.assistance_id = null;
      this.filter.assistance_plan_id = null;
      // this.categories = this.originalCategories;
    }
  }

  getProviders() {
    if (this.filter.assistance_id == null) {
      this.api.assistanceProviders.get()
        .filter({country_id: this.filter.country_id}).promise()
        .then(resp => {
          this.providers = resp.data;
          if (this.filter.provider_id) {
            this.filterProviderName = _.find(
              this.providers,
              c => c.id === this.filter.provider_id
            ).name;
          }
        });
    } else {
      this.api.assistancesById.getProviders(this.filter.assistance_id)
        .filter({country_id: this.filter.country_id}).promise()
        .then(resp => {
          this.providers = resp.data;
          if (this.filter.provider_id) {
            this.filterProviderName = _.find(
              this.providers,
              c => c.id === this.filter.provider_id
            ).name;
          }
        });
    }
  }

  filterAssistanceCase() {

    if (!this.dates_valid) {
      return;
    }

    //---asigno el arreglo de despachadors y operadores
    this.filter.dispatcher_array=this.dispatcher_array;
    this.filter.operator_array=this.operator_array

    this.page = 1;
    this.showDialogFilter = false;
    this.loaderService.display(true);
    this.caseSearchClear.emit(true);
    this.disabled = true;
    if (this.filter.category_id) {
      this.filterCategoryName = _.find(
        this.categories,
        c => c.id === this.filter.category_id
      ).name;
    } else {
      this.filterCategoryName = null;
    }
    if (this.filter.provider_id) {
      this.filterProviderName = _.find(
        this.providers,
        c => c.id === this.filter.provider_id
      ).name;
    } else {
      this.filterProviderName = null;
    }
    this.getAssistanceCase();
  }

  refresh() {
    this.loaderService.display(true);
    this.getAssistanceCase();
  }

  refreshBackground() {
    this.getAssistanceCase();
  }

  getAssistanceCase() {
    if (this.myTickets) {
      // Get id for user logged in to filter assistance cases
      // when myTickets enabled, then call to assistance cases
      this.api.me.get()
        .promise()
        .then(data => {
          this.me.updateToken(data);
          // this.filter.user = data;
          // this.filter.user_id = data.id;
          this.filterUserName = data.name;

          if (data && data.roles && data.roles.length && data.roles.indexOf("assistance_dispatcher_medical") >= 0) {
            this.filter.user_id = data.id;
          } else {
            this.filter.dispatcher_or_creator_id = data.id;
          }

          this._getAssistanceCase();
        })
        .catch(e => {
          
        })
    } else {
      return this._getAssistanceCase();
    }
  }

  _getAssistanceCase() {
    this.messageService.clear()
    const filter = Object.assign({}, this.filter);
    this.api.assistancecases.get()
      .filter(filter).sort('date_start', true)
      .page(this.page).per_page(10).promise()
      .then(assistancecases => {
        this.loaderService.display(false);
        this.disabled = false;
        this.assistancecases = assistancecases.data;
        this.totalCount = assistancecases.total;
        this.bufTotalCount = assistancecases.total;
        this.pageAssistancecases = this.assistancecases;
        if (this.assistancecases.length > 0) {
          const caseIds = [];
          let filters = []
          this.assistancecases.forEach(assistancecase => {
            caseIds.push(assistancecase.id);
          
            let filter = {
              reference_number: assistancecase["id"],
              country_id: assistancecase["country"]["id"],
              sponsor_id: assistancecase["assistance"]["sponsor_id"],
              service_id: assistancecase["services"][0]["id"],
              category_id: assistancecase["services"][0]["category_id"],
              contact_channel:assistancecase["contact_channel"],
              survey_type: 20
            };
          
            filters.push(filter);
          });
          this.api.surveys.exist_evaluate_and_survey(filters).promise().then(response => {
            if (response.status === 200) {
              this.assistancecases.forEach(assistancecase => {
                const matchingCase = filters.find(filter => filter.reference_number === assistancecase.id);
                const assistance_survey = response.data.find(survey => survey.reference_number === assistancecase.id)
                if (matchingCase) {
                  if (assistance_survey.answered) {
                    assistancecase["evaluado"] = true;
                  } else {
                    assistancecase["evaluado"] = false;
                  }
                  assistancecase["survey_id"] = assistance_survey.survey_id;
                }
              });
            } else {
              this.assistancecases.forEach(assistancecase => {
                assistancecase["evaluado"] = false;
                assistancecase["survey_id"] = -1;
              });
            }
          }).catch(error => {
            console.error('Error en la llamada a exist_evaluate_and_survey:', error);
          });

          this.api.assistancecases.get().filter(filter)
            .params({check_ticket_type: true, case_ids: caseIds.join(',')})
            .promise().then(rsp => {
              const cases_ticket_type = rsp.data;
              this.assistancecases.forEach(assistancecase => {
                assistancecase.show_elapsed_bar = true;
                if (assistancecase.services) {
                  assistancecase.services.forEach(service => {
                    const serviceInfo
                      = cases_ticket_type[assistancecase.id][service.id];

                    service.tickets = (serviceInfo.tickets || [])//.reverse();

                    // Get latest ticket that provider = will won't in servicegroup
                    let wont_index = null;
                    wont_index = _.findIndex(service.tickets, { 'provider_status': 2 });

                    // Set provider endtime, ArrivalStartTime in servicegroup
                    let assignprovider_index = null;
                    assignprovider_index = _.findIndex(service.tickets, { 'ticket_type': 2, 'provider_status': 1});
                    if (assignprovider_index > -1 ) {
                        if (wont_index === -1 || assignprovider_index < wont_index){
                          // this.providerEndTime[b.service_id] = this.servicegrouptickets[b.service_id][assignprovider_index].datetime;
                          service.arrivalStartTime = service.tickets[assignprovider_index].datetime;
                          // this.goprovider[b.service_id] = this.servicegrouptickets[b.service_id][assignprovider_index].provider;
                        } else {
                          // this.providerEndTime[b.service_id] = null;
                          service.arrivalStartTime = null;
                          // this.goprovider[b.service_id] = null;
                        }
                    } else {
                      // this.providerEndTime[b.service_id] = null;
                      service.arrivalStartTime = null;
                    }

                    // Find notify to customer ticket
                    let ntc_index = _.findIndex(service.tickets, { "ticket_type": 3 });
                    if (ntc_index >= 0) {
                      service.notifyToCustomerEndTime = service.tickets[ntc_index].datetime;
                    }

                    // Find if this case is programmed
                    let programmed_index = _.findIndex(service.tickets, { "ticket_type": 11 });
                    if (programmed_index >= 0) {
                      service.programedTicketStartTime = service.tickets[programmed_index].datetime;
                    }

                    service.ticket_type = serviceInfo.text;
                    service.is_from_app = serviceInfo.is_from_app
                    if(assistancecase.status ==  CASE_STATUSES.STATUS_OPEN && serviceInfo.text == "Programmed") {
                      let programmedDatetime = new Date(serviceInfo.datetime);
                      var currentDatetime = new Date();
                      programmedDatetime.setTime(programmedDatetime.getTime() + (assistancecase.country.timezone*60*60*1000));
                      if(currentDatetime >= programmedDatetime){
                        assistancecase.programmed_datetime = true;
                      }
                    }
                    if (service.ticket_type) {
                      assistancecase.show_elapsed_bar = false;
                    }

                    if (this.iam.roles.find(element => element == 'assistance_dispatcher')
                      || this.iam.roles.find(element => element == 'assistance_dispatcher_vial')
                      || this.iam.roles.find(element => element == 'assistance_dispatcher_medical')
                    ) {
                      // Set times for other bar
                      assistancecase.dispatcher_start
                        = serviceInfo.dispatcher_date_start;
                      assistancecase.dispatcher_end
                        = serviceInfo.dispatcher_date_end;

                      // this.isOnlyDispatcherRole = this.iam.hasThisRole(
                      //   'assistance_dispatcher'
                      // );
                      this.isOnlyDispatcherRole = true;
                    }
                  });
                }
              

              });
            });
        }
      })
      .catch(e => {
        this.loaderService.display(false);
        this.disabled = false;
        
          this.translate.get('Error getting cases').subscribe((res: string) => {
            this.messageService.add({
              severity: 'error', summary: 'Error', detail: `${res}`
            });
          });
        });
  }

  prevPage() {
    this.page -= 1;
    this.getAssistanceCase();
  }

  nextPage($event) {
    this.page = $event.page + 1;
    this.getAssistanceCase();
  }

  showModalFilter() {
    this.showDialogFilter = true;
    this.newMember.emit(this.filterMember);
  }

  showModalSave(member?: Member) {
    this.messageHeader = "Create Assistance Case"
    this.router.navigate([],{
      relativeTo: this.route,
      queryParams: {
        step:'1'
      },
      queryParamsHandling: 'merge'
    })
    this.createTicket.emit();
    if (member) {
      this.newMember.emit(member);
      this.assistancecase = new AssistanceCase();
      this.states = [];
      this.assistancecase.member = member;
      this.newMemberCountry.emit(member.country);
      this.assistancecase.country_id = member.country;
      this.assistancecase.contact_name = member.name;
      this.assistancecase.phone = member.mobile;
      this.assistancecase.member_status = 2;
      this.assistancecase.date_start = new Date().toISOString().slice(0, 19)
        .replace('T', ' ');
      this.status_flag =  'Create';
      this.caseLocation = null;
      this.showDialog = true;
      this.startCount.emit({showing: true});
    } else {
      this.assistancecase = new AssistanceCase();
      this.states = [];
      this.assistancecase.date_start = new Date().toISOString().slice(0, 19)
        .replace('T', ' ');
      this.status_flag = 'Create';
      this.caseLocation = null;
      this.showDialog = true;
      this.startCount.emit({showing: true});
    }
    this.editevent.emit();
  }

  changeStatus(assistancecase: AssistanceCase) {
    this.messageService.clear()
    this.api.assistancecases.update(assistancecase, assistancecase.id).promise()
      .then(c => {
        this.translate.get('Assistance case updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${c.id}`
            });
          });
      })
      .catch(e => {
        this.translate.get('Error updating assistance case')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`
            });
          });
      });
  }

  onSelectsearchCase(assistancecase: AssistanceCase): void {
    this.assistancecase = Object.assign({}, assistancecase);
    this.api.states.get(this.assistancecase.country_id).promise()
      .then(states => {
        this.states = states;
      });
    this.caseLocation = {
      latitude: assistancecase.latitude,
      longitude: assistancecase.longitude
    };
    this.status_flag = 'Update';
    this.showDialog = true;
    this.startCount.emit({showing: false});
    this.editevent.emit();
  }

  onSave(assistancecase: AssistanceCase) {
    this.filter.status = 1;
    if (assistancecase.is_new) {
      //this.assistancecases.unshift(assistancecase); //TO DO: arreglar esto, se puso asi porque los ngIf mata los emit y el nuevo objeto agregado no tiene el atributos servicios que hace que falle la vista
      this.showDialog = false;
      this.getAssistanceCase();
	  } else {
      this.assistancecases.forEach((a, k) => {
        if (a.id === assistancecase.id) {
          this.assistancecases[k] = assistancecase;
        }
      });
    }
    this.showDialog = false;
  }

  onDeleteItem(assistancecase: AssistanceCase) {
    this.messageService.clear()

    this.translate.get('Delete Assistance Case')
      .subscribe((res1: string) => {
        this.confirmation.confirm({
          message: `${res1} ${assistancecase.id}?`,
          key: 'delete-case',
          accept: () => {
            this.assistancecases = _.filter(
              this.assistancecases,
              a => a.id !== assistancecase.id
            );
            this.api.assistancecases.delete(assistancecase.id).promise()
              .then(() => {
                this.translate.get('Assistance case deleted')
                  .subscribe((res: string) => {
                    this.messageService.add({
                      severity: 'info',
                      summary: 'Info',
                      detail: `${res}: ${assistancecase.id}`
                    });
                  });
              })
              .catch(e => {
                this.translate.get('Error deleting assistance case')
                  .subscribe((res: string) => {
                    this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: `${res}: ${e.error}`
                    });
                  });
              });
          }
        });
      });
  }

  showFeedback(assistancecase: AssistanceCase) {
    
    this.case_id2 = assistancecase.id
    this.showDialogFeedback = true;
    this.assistancecaseFeedback = Object.assign({}, assistancecase);
    this.assistancecaseFeedback.rating_status =
      this.assistancecaseFeedback.rating_status != null
        ? this.assistancecaseFeedback.rating_status : 0;
    if (this.assistancecaseFeedback.rating_status !== 1) {
      // "Answered" is "No"
      this.showquestions = false;
    } else {
      // "Answered" is "Yes"
      this.showquestions = true;
    }
    this.selectedRecommendation =
      this.assistancecaseFeedback.recommendation_rating
        ? this.assistancecaseFeedback.recommendation_rating : 0;
    this.api.assistanceCasesByIdAssistanceServices.get(assistancecase.id).promise()
      .then(services => {
        this.services = services.data;
      });
  }

  onSelectRatingStatus(rating_status) {
    this.getSponsor()
    this.getTdType()
    this.assistancecaseFeedback.rating_status = parseInt(rating_status);
    if (this.assistancecaseFeedback.rating_status !== 1) {
      // "Answered" is "No"
      this.showquestions = false;
    } else {
      // "Answered" is "Yes"
      this.showquestions = true;
    }
  }
async getSponsor(){
  
  // const filter = Object.assign({}, this.filter);
  // filter['case_id']=this.case_id2
  // 
  // await this.api.assistancecases.getsponsor().filter(filter).promise().then(services => {
  //   this.unicom_exception = services;
  //   
  //   
  // });

}

async getTdType(){
  
  const filter = Object.assign({}, this.filter);
  filter['case_id']=this.case_id2
  
  await this.api.assistancecases.gettdtype().filter(filter).promise().then(type => {
    this.td_type = type;
    
    
  });

}
  onSpeedRating(speed_rating) {
    this.assistancecaseFeedback.speed_rating = parseInt(speed_rating);
  }

  onPhoneRating(phone_rating) {
    this.assistancecaseFeedback.phone_rating = parseInt(phone_rating);
  }

  onTimeRating(time_rating) {
    this.assistancecaseFeedback.time_rating = parseInt(time_rating);
  }

  onServiceRating(service_rating) {
    this.assistancecaseFeedback.service_rating = parseInt(service_rating);
  }

  onEffortRating(effort_rating) {
    this.assistancecaseFeedback.effort_rating = parseInt(effort_rating);
  }

  onPrevention_cov19_rating(prevention_rating){
    this.assistancecaseFeedback.prevention_cov19_rating = parseInt(prevention_rating);
  }

  onTip1(tip){
    this.assistancecaseFeedback.answered_tip1 = parseInt(tip);
  }

  onTip2(tip){
    this.assistancecaseFeedback.answered_tip2 = parseInt(tip);
    if(tip < 3){
      this.assistancecaseFeedback.answered_tip1 = 1
    }
  }

  selectRecommendation(recommendation) {
    this.assistancecaseFeedback.recommendation_rating =
      this.selectedRecommendation = parseInt(recommendation) + 1;
    if (this.assistancecaseFeedback.recommendation_rating < 7) {
      this.showReason = true;
    } else {
      this.showReason = false;
    }
  }

  onSelectReason(reason) {
    this.assistancecaseFeedback.reason = parseInt(reason);
  }

  hoverRecommendation(recommendation) {
    this.hoverRecommendationValue = recommendation + 1;
  }

  leaveRecommendation() {
    this.hoverRecommendationValue = null;
  }

  hoverStarService(star, index) {
    this.services[index].hoverStar = star + 1;
  }

  leaveHoverStarService(star, index) {
    this.services[index].hoverStar = null;
  }

  selectRating(star, index) {
    this.services[index].rating = parseInt(star) + 1;
  }

  showMemberInfo(assistancecase: AssistanceCase) {
    this.assistancecaseInfo = assistancecase;
  }

  showTimes(assistancecase: AssistanceCase) {
    this.assistancecaseTime = assistancecase;
  }

  createMember(member:Member) {
    this.showDialog = false;
    let _member = new Member();
    _member.country = member.country;
    _member.longitude = member.longitude;
    _member.latitude = member.latitude;
    _member.gender = 1;
    _member.relationship_status = 1;
    _member.status = 1;
    _member.flag = 'assistancecase';
    this.memberLocation.latitude=member.latitude;
    this.memberLocation.longitude = member.longitude;
    this.memberDialog = true;
    this.memberstate_flag = 'Create';
    this.member = _member;
    this.editmember.emit(_member);
  }

  onMemberSave(member: Member) {
    this.memberDialog = false;
    if (member.is_new) {
      this.showModalSave(member);
    }
  }

  cancelMember() {
    this.memberDialog = false;
    this.showDialog = true;
  }

  saveFeedback() {
    if (this.assistancecaseFeedback.rating_status == 1) {
      // "Answered" is "Yes"
      if (!this.assistancecaseFeedback.recommendation_rating) {
        this.fieldsRequired['recommendation_rating'] = true;
        return;
      }
      this.disabled = true;
      this.fieldsRequired['recommendation_rating'] = false;
      const data = {
        services: this.services,
        member_comment: this.assistancecaseFeedback.member_comment,
        rating_status: this.assistancecaseFeedback.rating_status,
        speed_rating: this.assistancecaseFeedback.speed_rating,
        phone_rating: this.assistancecaseFeedback.phone_rating,
        time_rating: this.assistancecaseFeedback.time_rating,
        service_rating: this.assistancecaseFeedback.service_rating,
        effort_rating: this.assistancecaseFeedback.effort_rating,
        recommendation_rating: this.assistancecaseFeedback.recommendation_rating,
        reason: this.assistancecaseFeedback.reason
      };
      this.api.assistanceCasesByIdAssistanceServices
        .putRating(this.assistancecaseFeedback.id, data).promise()
        .then(rsp => {
          this.disabled = false;
          this.assistancecases.forEach((value, key) => {
            if (value.id === rsp.data.id) {
              rsp.data.services = this.assistancecases[key].services;
              rsp.data.show_elapsed_bar = this.assistancecases[key].show_elapsed_bar;
              this.assistancecases[key] = rsp.data;
            }
          });
          this.showDialogFeedback = false;
        });
    } else { // "Answered" is "No"
      const data = {
        rating_status: this.assistancecaseFeedback.rating_status
      };
      this.disabled = true;
      this.api.assistanceCasesByIdAssistanceServices
        .putRating(this.assistancecaseFeedback.id, data).promise()
        .then(rsp => {
          this.disabled = false;
          this.assistancecases.forEach((value, key) => {
            if (value.id === rsp.data.id) {
              rsp.data.services = this.assistancecases[key].services;
              rsp.data.show_elapsed_bar = this.assistancecases[key].show_elapsed_bar;
              this.assistancecases[key] = rsp.data;
            }
          });
          this.showDialogFeedback = false;
        });
    }
  }

  onPaid(assistancecase) {
    this.showPaidDialog = true;
    this.assistancecasePaid = Object.assign({}, assistancecase);
    if (this.assistancecasePaid.is_paid === null) {
      this.assistancecasePaid.is_paid = 1;
    }
  }


  onSelectPaid(is_paid) {
    this.assistancecasePaid.is_paid = parseInt(is_paid);
  }

  onSelectPaymentMethod(payment_method) {
    this.assistancecasePaid.payment_method = parseInt(payment_method);
  }

  savePaid() {
    const paid_data = {
      is_paid: parseInt(this.assistancecasePaid.is_paid),
      payment_method: parseInt(this.assistancecasePaid.payment_method),
      bill_comment: this.assistancecasePaid.bill_comment
    };
    this.disabled = true;
    this.api.assistancecaseByIdPaid.put(this.assistancecasePaid.id, paid_data)
      .promise()
      .then(resp => {
        this.disabled = false;
        this.assistancecases.forEach((val, key) => {
          if (val.id === resp.data.id) {
            resp.data.services = this.assistancecases[key].services;
            resp.data.show_elapsed_bar = this.assistancecases[key].show_elapsed_bar;
            this.assistancecases[key] = resp.data;
          }
        });
      });
    this.showPaidDialog = false;
  }

  onCancel() {
    this.showDialogFeedback = false;
    this.showPaidDialog = false;
    this.showSurcveyDialog = false;
    this.fieldsRequired['recommendation_rating'] = false;
  }

  translateFeedbackOptions() {
    this.effort_ratings = this.translateArrayTexts(this.effort_ratings);

    this.ratings = this.translateArrayTexts(this.ratings);
  }

  translateArrayTexts(arrayTexts: any[]) {
    const texts = this.getTexts(arrayTexts);

    if (texts.length <= 0) {
      return arrayTexts;
    }

    // Translate efforts
    this.translate.get(texts)
      .subscribe((res: any) => {
        for (let i = 0; i < arrayTexts.length; ++i) {
          arrayTexts[i].text = res[arrayTexts[i].text];
        }
      });

    return arrayTexts;
  }

  getTexts(textsObj: any) {
    const texts = [];

    for (let i = 0; i < textsObj.length; ++i) {
      if (textsObj[i].text) {
        texts.push(textsObj[i].text);
      }
    }

    return texts;
  }

  downloadCsv() {
    this.showDialogDownloadReport = true;
    this.downloadReport = {
      file_type: 'xlsx',
      filter: {}
    };
  }

  downloadCsvQA() {
    this.showDialogDownloadReport = true;
    this.downloadReport = {
      file_type: 'csv',
      filter: {}
    };
  }
  submenu_qa(assistance_case) {
    this.showDialogQA = true;
    
    this.temp_assistance_case = assistance_case
    
   
  }

  submenu_alert(assistance_case) {
    //this.showDialogAlert = true;
    
    //this.temp_assistance_case = assistance_case
    
   
  }
  async submenu_qa3(assistance_case) {
    this.loaderService.display(true);
    this.temp_assistance_case = assistance_case


    await this.api.assistancecases.getSurveyName(assistance_case.id).promise()
    .then(resp=>{
  
      this.showSurvey(this.temp_assistance_case,resp[1])         
      this.loaderService.display(false);
    }).catch(error=>{
      this.loaderService.display(false);
      console.error(error);
    })
    
   
  }



  answer_complete(respuesta,id){
   
   
   

   return "completa"+respuesta
  }
  
 aplica(val){
   this.aplica_ = val;
 }

 async aplica_update_question(val,assistancecase_){
  this.loaderService.display(true);
   this.aplica_update = val
   //
   //
   await this.api.assistancecases.getSurveyName(assistancecase_.id).promise()
      .then(resp=>{
        this.group_type_update = resp[1]
      })

      
   
   const filter = {group_type: this.group_type_update}; //probando quemado
   this.api.assistancecases.getquestions(assistancecase_.id)
            //this.api.assistancecases.getquestions(data.case)
              .filter(filter)
              .promise().then(resp => {
                //
                //
                //
                //
                //
                //
                this.questions_officer_update = resp[0];

                this.questions_officer_update_answers = resp[1];

                this.questions_officer_update['0'].questions = this.questions_officer_update['0'].questions.map(q => {
                  let respuesta = this.questions_officer_update_answers.find(f => f.question_id == q.id
                    )
                    
                    
                    return {...q,respuesta:respuesta}
                })
                this.loaderService.display(false);
              })
              .catch(e => {
                this.loaderService.display(false);
              });
   
 }
   
  disable_pauta_aplica2 = false;
  aplica2(){

    
    
    const filter = { 'questions': this.questions_officer, "val":this.aplica_, "approved_comment":this.approved_comment};
    this.disable_pauta_aplica2 = true;
    this.loaderService.display(true);
    this.api.assistancecases.update_officer({
      aplica_update:this.aplica_update,
      approved_comment_update: this.approved_comment_update,
      questions_update:this.questions_officer_update, 
      questions: this.questions_officer, 
      val:this.aplica_, 
      approved_comment:this.approved_comment,
      case: this.assistance_case_id
    }).promise()
    .then(resp => {
        
        
    
        resp[3].forEach(element => {
            
            
            
            
        
        this.questions_officer = resp[3]
        
        
        
        

        });  
       
      
      

            this.disable_pauta_aplica2 = false;
            this.loaderService.display(false);
      
           
          })
          .catch(e => {
            this.disable_pauta_aplica2 = false;
            this.loaderService.display(false);
          })
          this.showDialogQA2 = false;

   }
  async submenu_qa2(assistance_case) {
    this.loaderService.display(true);
    this.questions_officer = [];
    this.temp_assistance_case = assistance_case;
    this.assistance_case_id = assistance_case.id;
    
    //consultar que tipo de pauta es 
    await this.api.assistancecases.getSurveyName(assistance_case.id).promise()
    .then(resp=>{
        
        // resp[3].forEach(element => {
        //   this.questions_officer = resp[3]
        //   //this.questions_officer_update = resp[3]
        //   this.comment_user = resp[4]
        //   this.not_apply_details = resp[5].filter(element=> element.type == resp[1]);

        // });  
        this.questions_officer = resp[3];
        //this.questions_officer_update = resp[3]
        this.comment_user = resp[4]
        this.not_apply_details = resp[5].find(element=> element.type == resp[1]);

        if(this.not_apply_details && this.not_apply_details.tip1 > 1){
          this.fit_criteria_ = 0;
        }
        else{
          this.fit_criteria_ = 1;

        }

        if(Array.isArray(resp[3]) && resp[3].length > 1){
          
          this.fit_criteria = resp[3][0][0].approved;
          this.approved_comment = resp[3][0][0].approved_comment;
        }
        else{
          
        }
        this.aplica_update = resp[5][0].validated_questions_with_client;
        this.aplica_update_question(this.aplica_update,assistance_case);
        this.loaderService.display(false);

        }).catch(error=>{
          this.loaderService.display(false);
          console.error(error);
        })
        this.showDialogQA2 = true;
  }
  saveDownloadReport() {
    this.messageService.clear()
    this.downloadReport.filter = this.filter;
    this.api.assistancecases.createReportAttachment(this.downloadReport).promise()
      .then(report => {
        this.translate.get('Report added to queue')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: #${report.id}`
            });
          });
      })
      .catch(e => {
        this.translate.get('Report data error')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.statusText}`
            });
          });
      });
    this.showDialogDownloadReport = false;
  }

  cancelDownloadReport() {
    this.showDialogDownloadReport = false;
  }
  showsubSurvey(group_type:number){
    
    
    
    
    this.showSurvey(this.temp_assistance_case,group_type)
  }
  showSurvey(a_case: AssistanceCase, groupType: number) {
    
    

    if(groupType == -1){
      
      
      
      this.survey_type = groupType
      let groupType2 ;
      //consultar que tipo de pauta es 
      this.api.assistancecases.getSurveyName(a_case.id).promise()
      .then(resp=>{
      
      this.showDialogQA2 = true;
      this.editSurveyCase = a_case;
      
      
      this.editSurveyCase.suggested_answers = [];
      this.editsurvey.emit({
        editcase: this.editSurveyCase,
        groupType: resp[1]
  
      })
  
       
      })

      

    } else{
    
    
    
    this.survey_type = groupType
    let groupType2 ;
    //consultar que tipo de TD es
    this.api.assistancecases.getConsultationType(a_case.id).promise()
    .then(resp=>{

      if(groupType===9){

 if(resp == 5){
   this.isTD = true
   
        
        groupType2 = 10
        this.survey_type = 10
      } else if(resp == 6){
       this.isTD = true
       
       
       groupType2 = 11
       this.survey_type = 11
     } else if(resp == 7){
       this.isTD = true
       
       
       groupType2 = 12
       this.survey_type = 12
     }
      }
       else{
        this.isTD = false
        
      
      groupType2 = groupType
     }


    this.showSurcveyDialog = true;
    this.editSurveyCase = a_case;
    this.editSurveyCase.suggested_answers = [];
    this.editsurvey.emit({
      editcase: this.editSurveyCase,
      groupType: groupType2

    })


    })

    //


  }
}

  onUpdateSurvey(editcase: any) {
    this.showSurcveyDialog = false;
    this.messageService.clear()
    this.api.assistancecases.postanswers(Object.assign({}, editcase)).promise()
      .then(resp => {
        this.translate.get('Answers saved')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}`
            });
          });
        const answeredcase =  _.find(
          this.assistancecases,
          assistancecase => assistancecase.id === editcase.id
        );

        if (editcase.survey_group_type === Group.ASSISTANCE_CASE_SURVEY) {
          answeredcase.surveyanswered = true;
        }
        else if (editcase.survey_group_type === Group.ASSISTANCE_CASE_DISPATCHER_SURVEY) {
          answeredcase.dispatch_survey_answered = true;
        }
      })
      .catch(e => {
        this.translate.get('Error saving answers')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.statusText}`
            });
          });
      });
  }

  onNotificationReceived(caseId:number) {
    this.assistancecases = this.assistancecases.map(itemCase => {
       if (itemCase.id == caseId) {
         itemCase.programmed_datetime = true;
         return itemCase;
       }
       return itemCase
    });
  }
  /**  getSomeClass(service_id: number, program:any,country:any, assistancecase_id:number){
    
    
    
    
    */

    
    validateColor(service_id: any, program:any,plan:any,country:number, is_from_app:boolean){
      
      if(service_id != null){
        if(program ==true){
          return {programmed_case:true};
        }else{
          if(service_id[0].id == 19 || (plan && plan.name.toLowerCase() == "vip")){
            return is_from_app ? 4 : 1;
          } else if (service_id[0].id == 20 || service_id == 348){
            return is_from_app ? 5 : 2;
          } else if (country == 10 || country == 11) {
            return is_from_app ? 6 : 3
          } else {
            return is_from_app ? 7 : {programmed_case:false};
          }
        }
      }
      else {
        return {programmed_case:false};
      }
    }
    
    getSomeClass(service_id: any, program:any,plan:any,country:number){

      if(service_id != null){
        if(program ==true){
          return {programmed_case:true};
        }else{
          if(service_id[0].id == 19 || (plan && plan.name.toLowerCase() == "vip")){
            return {priority1_case:true};
          } else if (service_id[0].id == 20 || service_id == 348){
            return {priority2_case:true};
          } else if (country == 10 || country == 11) {
            return {priority3_case:true}
          } else {
            return {programmed_case:false};
          }
        }
      }
      else {
        return {programmed_case:false};
      }
    }




    onSelectCategory(category_id) {

      if (category_id) {
          this.selectCategory_id = parseInt(category_id);
          this.editcategory = _.find(this.categories, p => p.id == this.selectCategory_id);


            // No assistance case


            this.api
              .assistanceserviceCategoryProductPlan
              .get2(this.selectCategory_id).promise()
              .then(s => {
                this.services_filter = s.data;
              });



      } else {
        this.services_filter = [];

      }


    }
  onNotificationRefresh(payload){
    if(payload.Mailbox) {
      this.refreshBackground()
    }
  }

  onNotificationTicektRefresh(payload){
    if(payload.update_ticket_case) {
      setTimeout(() => 
      {
        this.refreshBackground()
      },
      2500);
    }
  }


  changeMessageNavBar(value){

    this.messageHeader  = value;

  }

  //buttons for the filter 
    filterException(valor){
      if(this.filter.exception_ticket !=null){
        if((this.filter.exception_ticket == 1 && valor == 1) || (this.filter.exception_ticket ==2 && valor == 2)){
          document.getElementById("btnYexception").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnYexception").style.color = "#000000"
          document.getElementById("btnNexception").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnNexception").style.color = "#000000"
          this.filter.exception_ticket = null
        }
        else {
          if(valor == 1){
            document.getElementById("btnYexception").style.backgroundColor = "#01579B"
            document.getElementById("btnYexception").style.color = "#FFFFFF"
            document.getElementById("btnNexception").style.backgroundColor = "#f8f8f8"
            document.getElementById("btnNexception").style.color = "#000000"
            this.filter.exception_ticket = 1
          }
          else{
            document.getElementById("btnNexception").style.backgroundColor = "#01579B"
            document.getElementById("btnNexception").style.color = "#FFFFFF"
            document.getElementById("btnYexception").style.backgroundColor = "#f8f8f8"
            document.getElementById("btnYexception").style.color = "#000000"
            this.filter.exception_ticket = 2
          }
        }
      }
      else{
        if(valor == 1){
          document.getElementById("btnYexception").style.backgroundColor = "#01579B"
          document.getElementById("btnYexception").style.color = "#FFFFFF"
          document.getElementById("btnNexception").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnNexception").style.color = "#000000"
          this.filter.exception_ticket = 1
        }
        else{
          document.getElementById("btnNexception").style.backgroundColor = "#01579B"
          document.getElementById("btnNexception").style.color = "#FFFFFF"
          document.getElementById("btnYexception").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnYexception").style.color = "#000000"
          this.filter.exception_ticket = 2
        }
      }
    }
    filterProgrammed(valor){
      if(this.filter.programmed_ticket !=null){
        if((this.filter.programmed_ticket == 1 && valor == 1) || (this.filter.programmed_ticket ==2 && valor == 2)){
          document.getElementById("btnYprogramed").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnYprogramed").style.color = "#000000"
          document.getElementById("btnNprogramed").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnNprogramed").style.color = "#000000"
          this.filter.programmed_ticket = null
        }
        else {
          if(valor == 1){
            document.getElementById("btnYprogramed").style.backgroundColor = "#01579B"
            document.getElementById("btnYprogramed").style.color = "#FFFFFF"
            document.getElementById("btnNprogramed").style.backgroundColor = "#f8f8f8"
            document.getElementById("btnNprogramed").style.color = "#000000"
            this.filter.programmed_ticket = 1
          }
          else{
            document.getElementById("btnNprogramed").style.backgroundColor = "#01579B"
            document.getElementById("btnNprogramed").style.color = "#FFFFFF"
            document.getElementById("btnYprogramed").style.backgroundColor = "#f8f8f8"
            document.getElementById("btnYprogramed").style.color = "#000000"
            this.filter.programmed_ticket = 2
          }
        }
      }
      else{
        if(valor == 1){
          document.getElementById("btnYprogramed").style.backgroundColor = "#01579B"
          document.getElementById("btnYprogramed").style.color = "#FFFFFF"
          document.getElementById("btnNprogramed").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnNprogramed").style.color = "#000000"
          this.filter.programmed_ticket = 1
        }
        else{
          document.getElementById("btnNprogramed").style.backgroundColor = "#01579B"
          document.getElementById("btnNprogramed").style.color = "#FFFFFF"
          document.getElementById("btnYprogramed").style.backgroundColor = "#f8f8f8"
          document.getElementById("btnYprogramed").style.color = "#000000"
          this.filter.programmed_ticket = 2
        }
      }
    }
    getDate(date){
      try {
        
        let justdate = date.split("T")[0].split("-")
        
        return justdate[2]+'-'+justdate[1]+'-'+justdate[0]
      } catch (error) {
        return "?"
      }
    }







    openSelectSendSurvey(entry){
      //
      //return
      this.customer_phone=entry?.phone;
      this.id_survey=entry?.survey_id;
      this.currentProcessId=entry?.id;
      this.customer_email= entry?.email;
      this.country_id= entry?.country.id;
      this.customer_name= entry?.member?.name;
      this.open=true;
  
  
    }
  
    openDialogPauta(assistance_case) {
      
      sessionStorage.setItem('returnUrl', this.router.url);
     // this.open_modal_pauta = true;
      this.currentProcessIdPauta=assistance_case?.id;
      this.id_pauta=assistance_case?.id_pauta;
      //this.temp_assistance_case = assistance_case
      
      this.country_id=assistance_case["country"]["id"]
      this.sponsor_id= assistance_case["assistance"]["sponsor_id"]
      this.service_id= assistance_case["services"][0]["id"]
      this.category_id=assistance_case["services"][0]["category_id"]
      

      const qp = {
        reference_number: assistance_case?.id,
        id_pauta: assistance_case?.id_pauta,
        country_id: assistance_case?.country?.id,
        sponsor_id: assistance_case?.assistance?.sponsor_id,
        service_id: assistance_case?.services?.[0]?.id,
        category_id: assistance_case?.services?.[0]?.category_id,
        pauta_type : 20 // asistencias
      };

      this.router.navigate(['admin/user-pauta-list'], { queryParams: qp });
      //this.open_modal_pauta = true;
    }



}
